module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-sg/tab-b87484b3f6b7cf2ba6f558375af9f8a9.png";